import * as PA from '../actions/paymentActions';
import {RSAA} from 'redux-api-middleware'
import store from 'store';


export function completeOnlineCollection(id, total, type, appFeeType, isExpedited, personId) {
  return {
    [RSAA]: {
      endpoint: `/paydotgov/completeOnlineCollection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(
        { id, total, type, appFeeType, isExpedited, personId }
      ),
      types: [
        PA.CONFIRM_AUTHORIZATION_REQUEST,
        PA.CONFIRM_AUTHORIZATION_SUCCESS,
        PA.CONFIRM_AUTHORIZATION_FAILURE
      ]
    }
  }
}


export function cancelOnlineCollection(id) {
  return {
    [RSAA]: {
      endpoint: `/paydotgov/cancelOnlineCollection`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(
        id
      ),
      types: [
        PA.CANCEL_AUTHORIZATION_REQUEST,
        PA.CANCEL_AUTHORIZATION_SUCCESS,
        PA.CANCEL_AUTHORIZATION_FAILURE
      ]
    }
  }
}
